import React from 'react';
import {
    Input,
    Form,
} from 'antd';

import './index.less';

const GSTTable = (props) => {
    const { itemList, stateName, gst } = props;

    const validItems = (itemList || []).filter(
        (item) => item.unitRate && item.quantity && item.gstRate
    );

    const uniqueGstRates = [
        ...new Set(validItems.map((item) => parseFloat(item.gstRate))),
    ].sort((a, b) => b - a);

    // Missing GSTIN → treat as local (CGST/SGST); both present & differ → IGST
    const customerState = stateName ? String(stateName).slice(0, 2) : "";
    const branchState = gst ? String(gst).slice(0, 2) : "";
    const isLocalState =
        !customerState || !branchState || customerState === branchState;

    return (
        <>
            {uniqueGstRates.map((rate) => {
                const groupCGST = validItems
                    .filter((item) => parseFloat(item.gstRate) === rate)
                    .reduce((sum, item) => sum + (parseFloat(item.cgstAmount) || 0), 0);
                const groupSGST = validItems
                    .filter((item) => parseFloat(item.gstRate) === rate)
                    .reduce((sum, item) => sum + (parseFloat(item.sgstAmount) || 0), 0);
                const groupIGST = validItems
                    .filter((item) => parseFloat(item.gstRate) === rate)
                    .reduce((sum, item) => {
                        const lineIgst = parseFloat(item.igstAmount) || 0;
                        return sum + (lineIgst > 0
                            ? lineIgst
                            : (parseFloat(item.cgstAmount) || 0) + (parseFloat(item.sgstAmount) || 0));
                    }, 0);

                if (isLocalState) {
                    return (
                        <React.Fragment key={rate}>
                            <Form.Item
                                className="form-element"
                                label="CGST"
                                name={`cgst_${rate}`}
                            >
                                <div className="gst">
                                    <span>{rate / 2}%</span>
                                    <Input
                                        placeholder="CGST"
                                        disabled={true}
                                        value={groupCGST.toFixed(2)}
                                    />
                                </div>
                            </Form.Item>
                            <Form.Item
                                className="form-element"
                                label="SGST"
                                name={`sgst_${rate}`}
                            >
                                <div className="gst">
                                    <span>{rate / 2}%</span>
                                    <Input
                                        disabled={true}
                                        placeholder="SGST"
                                        value={groupSGST.toFixed(2)}
                                    />
                                </div>
                            </Form.Item>
                        </React.Fragment>
                    );
                }

                return (
                    <Form.Item
                        key={rate}
                        className="form-element"
                        label="IGST"
                        name={`igst_${rate}`}
                    >
                        <div className="gst">
                            <span>{rate}%</span>
                            <Input
                                disabled={true}
                                placeholder="IGST"
                                value={groupIGST.toFixed(2)}
                            />
                        </div>
                    </Form.Item>
                );
            })}
        </>
    );
};

export default GSTTable;
